// src/utils/toastUtils.js
// Chakra UI v3 uses the "toaster" API. Make sure you've added the Toaster snippet
// and that <Toaster /> is rendered once near your app root.
//
// Adjust the import path to wherever the snippet lives in YOUR project.
// If you used the CLI snippet defaults, it's usually "src/components/ui/toaster".
import { toaster } from "../components/ui/toaster"; // <-- change path if needed

// Shared defaults (roughly equivalent to your old settings)
const baseConfig = {
  placement: "top-end", // v3 positions: "top-start" | "top" | "top-end" | "bottom-..."
  duration: 4000,       // ms
  closable: true,
  // You can also pass 'render' for custom content if needed
};

// Generic helper if you want to call with custom options elsewhere
export const showToast = (options = {}) => {
  return toaster.create({
    ...baseConfig,
    ...options,
  });
};

export const showSuccess = (title, description) => {
  return toaster.success({
    ...baseConfig,
    title,
    description,
  });
};

export const showError = (title, description) => {
  return toaster.error({
    ...baseConfig,
    title,
    description,
    duration: 5000,
  });
};

export const showWarning = (title, description) => {
  return toaster.warning({
    ...baseConfig,
    title,
    description,
  });
};

export const showInfo = (title, description) => {
  return toaster.info({
    ...baseConfig,
    title,
    description,
  });
};